module.exports = __webpack_public_path__ + "img/handle.8bbc6190.png";